export default __webpack_public_path__ + "static/media/skincare.25081221.jpg";